var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton",class:{ 'skeleton-loading': _vm.loading }},[_c('v-skeleton-loader',{ref:"skeleton",staticClass:"videoStream_skeleton videoStream_skeleton-1",attrs:{"type":"image, table-heading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }